export const downloadFile = (source: Blob | string, fileName: string): void => {
  const link = document.createElement('a')
  const isBlob = source instanceof Blob

  link.href = isBlob ? URL.createObjectURL(source) : source
  link.download = fileName
  link.target = '_blank'

  document.body.append(link)
  link.click()
  link.remove()

  if (isBlob) {
    setTimeout(() => URL.revokeObjectURL(link.href), 5000)
  }
}
